/**
 * Tournament standings copy (specs/champions-league, Story 5).
 */

export const TOURNAMENT_STANDINGS_EMPTY_TITLE = 'No table yet';
export const TOURNAMENT_STANDINGS_EMPTY_SUBTITLE =
  'The table appears once the first matches have been played.';
export const TOURNAMENT_STANDINGS_ERROR_TITLE = "Couldn't load the table";
export const TOURNAMENT_STANDINGS_RETRY = 'Retry';

export const TOURNAMENT_STANDINGS_TEST_IDS = {
  screen: 'tournament-standings',
  table: (index: number) => `tournament-standings-table-${index}`,
  heading: (index: number) => `tournament-standings-heading-${index}`,
  empty: 'tournament-standings-empty',
  error: 'tournament-standings-error',
  retry: 'tournament-standings-retry',
} as const;
